import type { Ref } from 'vue'

type LocaleEntry = string | { code: string; language?: string }
type I18nLike = {
  locale: Ref<string>
  locales: Ref<LocaleEntry[]>
}

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n as I18nLike | undefined
  if (!i18n) return

  useHead({
    htmlAttrs: {
      lang: computed(() => {
        const locale = i18n.locale.value
        const match = i18n.locales.value.find(
          (l) => (typeof l === 'object' ? l.code : l) === locale
        )
        // `language` is the i18n v10 field name (`iso` was its deprecated
        // alias) — keep in sync with nuxt.config.ts i18n.locales.
        return (typeof match === 'object' ? match.language : locale) || 'en'
      }),
    },
  })
})
